import React from 'react';
import { Card, Row, Col, Table, Statistic } from 'antd';
import { cardDeckCols } from '../../utils/DataUtils';
import { motion } from 'motion/react';

function Deck(props) {
  // console.warn('props di deck: ',props);
  // let navigate = useNavigate();
  
  const deck = (props.deck && props.deck.value && props.deck.value.payLoad !== null ? props.deck.value.payLoad : {})
  const decklist = (props.deck && props.deck.value && props.deck.value.payLoad !== null ? props.deck.value.payLoad.deckList : [])

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px' }}>
    <Card loading={!props.deck.fulfilled && props.deck.pending} title={deck.deckName}>
      <Row gutter={16}>
        <Col span={24}>
            <Statistic title="Link" value={deck.deckLink} />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Card title="Main">
              <Table 
                size="small"
                showHeader={false}
                columns={cardDeckCols}
                dataSource={decklist.mainboard || []} 
                pagination={false} />
          </Card>
        </Col>
        <Col span={6}>
          <Card title="Sideboard">
              <Table 
                size="small"
                showHeader={false}
                columns={cardDeckCols}
                dataSource={decklist.sideboard || []} 
                pagination={false} />
          </Card>
        </Col>
      </Row>
    </Card>
    </motion.div>
  );
}

export default Deck;